module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/switcher/switcher.component.scss
// module id = ./src/app/components/tools/switcher/switcher.component.scss
// module chunks = main